<template>
	<div id="App">
		<div id="AppWrap">
			<b-navbar
				id="headernav"
				toggleable="lg"
				type="light"
				variant="light"
			>
				<b-navbar-brand to="#">
					<img
						id="logo"
						:src="logo"
						class="d-inline-block align-top"
					/>
				</b-navbar-brand>

				<b-navbar-toggle target="#" @click="menu = true">
					<template #default="{ expanded }">
						<md-icon
							class="menu-icon"
							v-if="expanded"
							icon="menu_open"
						></md-icon>
						<md-icon class="menu-icon" v-else icon="menu"></md-icon>
					</template>
				</b-navbar-toggle>

				<b-collapse id="nav-collapse" is-nav>
					<b-navbar-nav> </b-navbar-nav>
					<b-navbar-nav>
						<b-nav-item to="/">
							<md-icon icon="directions_car" /> {{ $t("global.bookings") }}
						</b-nav-item>

						<b-nav-item to="/rates"><md-icon icon="local_atm" />{{ $t('global.rates') }}</b-nav-item>
						<b-nav-item to="/design"><md-icon icon="design_services" /> {{ $t('global.design') }}</b-nav-item>
						<b-nav-item to="/settings"><md-icon icon="settings_suggest" /> {{ $t('global.settings') }}</b-nav-item>

						<b-nav-item v-if="$root.userCan('users')" to="/users"><md-icon icon="supervisor_account" />{{ $t("global.users") }}</b-nav-item>
					</b-navbar-nav>

					<!-- Right aligned nav items -->
					<b-navbar-nav class="ml-auto">
						<b-nav-item-dropdown right v-if="emailVerified === 'unverified_email'">
							<template v-slot:button-content class="position-relative">
								<md-icon class="notification" icon="notifications" v-b-tooltip.hover :title="$t('notifications.hasNotification')"/>
								<span class="position-absolute badge rounded-pill bg-danger notification-badge">1</span>
							</template>
							<!-- header -->
							<template>
								<p class="px-2 pt-0 border-bottom dropdown-header" style="width: 205px;">{{$t('notifications.notifications')}}</p>
							</template>
							<!-- body -->
							<b-dropdown-item v-b-modal.modal-notification-preview>
								<template>
									<div class="pt-2 pb-1">
										<p class="notification-title mb-0">{{$t('notifications.systemSc')}}</p>
										<p class="text-muted small mb-0">{{$t('notifications.confirmEmail')}}</p>
									</div>
								</template>
							</b-dropdown-item>
							
						</b-nav-item-dropdown>
						
						<h5><b-badge @click="changePlatform" v-b-tooltip.hover v-b-tooltip.placement.auto :title="this.$t('global.changePlatform')" class="btn mt-2 ml-2 mr-1 font-weight-normal" variant="info">{{system.code}}</b-badge></h5>

						<h6><b-badge class="btn ml-2 mr-4 font-weight-normal" v-b-tooltip.hover v-b-tooltip.placement.auto :title="this.$t('tooltips.statusPos', {status: liveText})" @click="switchLive" :variant="liveClass" style="margin-top: 12px">{{liveText}}</b-badge></h6>
						<b-avatar
							variant="primary"
							:text="user.firstName.charAt(0)"
						></b-avatar>
						<b-nav-item-dropdown right>
							<template v-slot:button-content>
								<em>{{ user.email }}</em>
							</template>
							<b-dropdown-item to="/profile"
								><md-icon icon="account_circle" />
								{{ $t("global.profile") }}</b-dropdown-item
							>
							<b-dropdown-divider />
							<b-dropdown-item to="#" @click="logout"
								>{{ $t("global.logout") }}
								<md-icon icon="time_to_leave"/><md-icon
									icon="directions_run"
							/></b-dropdown-item>
						</b-nav-item-dropdown>
					</b-navbar-nav>
				</b-collapse>
			</b-navbar>
			<slot></slot>
		</div>

		<b-sidebar title="Menu" shadow v-model="menu" backdrop>
			<nav class="mb-3">
				<b-nav vertical>
					<h5><b-badge @click="changePlatform" v-b-tooltip.hover v-b-tooltip.placement.auto :title="this.$t('global.changePlatform')" class="btn mt-2 ml-2 mr-4 font-weight-normal" variant="info">{{system.code}}</b-badge></h5>
					<h6><b-badge class="btn ml-2 mr-4 font-weight-normal" v-b-tooltip.hover v-b-tooltip.placement.auto :title="this.$t('tooltips.statusPos', {status: liveText})" @click="switchLive" :variant="liveClass" style="margin-top: 12px">{{liveText}}</b-badge></h6>
					<b-dropdown-divider></b-dropdown-divider>

					<b-nav-item to="/"><md-icon icon="directions_car" />{{ $t("global.bookings") }}</b-nav-item>
					<b-nav-item to="/rates"><md-icon icon="local_atm" />{{ $t('global.rates') }}</b-nav-item>
					<b-nav-item to="/design"><md-icon icon="design_services" />{{ $t('global.design') }}</b-nav-item>
					<b-nav-item to="/settings"><md-icon icon="settings_suggest" />{{ $t('global.settings') }}</b-nav-item>
					<b-nav-item v-if="$root.userCan('users')" to="/users"><md-icon icon="supervisor_account" />{{ $t("global.users") }}</b-nav-item>
					<b-dropdown-divider></b-dropdown-divider>

					<b-nav-item href="/profile" @click="setRoute"><md-icon icon="account_circle"/> {{ $t('global.profile') }}</b-nav-item>
					<b-nav-item href="#" @click="logout">{{ $t("global.logout") }} <md-icon icon="time_to_leave" /><md-icon icon="directions_run" /></b-nav-item>

				</b-nav>
			</nav>
		</b-sidebar>

		<footer>
			<div class="fab-contact">
				<b-button variant="success" v-b-tooltip.hover title="Support" v-b-tooltip.left class="shadow" @click="openContact"><md-icon icon="contact_support" /></b-button>
			</div>

			<img :src="logo" />
		</footer>
		
		<b-modal
			id="warning-alert"
			size="sm"
			body-class="position-static"
			hide-header
			centered
			no-fade
		>
			{{ warningProps.message || $t('warnings.okToContinue') }}
			<template #modal-footer="{ close }">
				<b-button
					:disabled="warningProps.loading"
					@click="close()"
					type="button"
					class="float-right"
				>
					{{$t('warnings.cancel')}}
				</b-button>
				<b-button
					:disabled="warningProps.loading"
					@click="
						event =>
							warningProps.okAction(
								event,
								warningProps.setLoading,
								close
							)
					"
					type="button"
					variant="primary"
					class="float-right"
				>
					<span v-if="!warningProps.loading">{{$t('warnings.continue')}}</span>
					<span v-else
						><b-spinner small></b-spinner> {{$t('warnings.processing')}}...</span
					>
				</b-button>
			</template>
		</b-modal>

		<b-modal 
			id="modal-notification-preview"
			size="sm"
			hide-footer
			v-if="emailVerified === 'unverified_email'"
			:title="$t('notifications.systemSc')">
			<p v-html="$t('notifications.confirmEmailBody', {user: user.firstName})"></p>

			<b-button variant="primary" block @click="resendEmail">{{$t('notifications.resendEmail')}} &#x1F4E8;</b-button>
		</b-modal>

		<!-- change platform -->
		<FormChangePlatform ref="modalChangePlatform"/>

		<!-- modal contact -->
		<SingleContact ref="modalContact"/>
	</div>
</template>

<script>
import logo from "../../../assets/logo-sc-azul.png";
import FormChangePlatform from "../../helpers/FormChangePlatform";
import SingleContact from "../../helpers/SingleContact";
import chatProvider from "@/components/helpers/helpers-chat";

export default {
	components: {FormChangePlatform, SingleContact},
	data() {
		return {
			logo,
			menu: false,
			live: 'offline',
			liveText: '',
			liveClass: 'danger',
			emailVerified: '',
		};
	},
	methods: {
		logout() {
			this.$root.api.post('/auth/logout').then(() => {
				this.$root.auxVars.clearResources();
				this.$root.store.clearUser();
				this.$router.push("/login");

				if (this.$root.chatStarted) {
					chatProvider.shutdown()
					this.$root.chatStarted = false;
				}
			}).catch(() => {
				this.error = true;
			})
		},
		setRoute(evt) {
			this.$root.setRouteEvt(evt);
		},
		changePlatform() {
			this.$refs["modalChangePlatform"].loadModel();
		},
		openContact() {
			this.$refs["modalContact"].loadModel();
		},
		resendEmail() {
			this.$root.api.post('/send-email').then((res) => {
				if(res.data.success) {
					this.$root.showAlert(this.$t('verifyEmail.emailSent'))
					this.$bvModal.hide('modal-notification-preview')
				}
			}).catch(err => {
				this.$root.handleRequestError(err)
			})
		},
		switchLive() {
			this.$root.showWarning({
				message: this.$t('warnings.changeStatusPOS'),
				okAction: (event, setLoading, close) => {
					setLoading(true)

					this.live = this.$root.store.state.currentSystem.system.live ? 'offline' : 'online'
					this.$root.api.post("/point-of-sales/live", { status: this.live }).then((res) => {
						if(res.data.success) {
							this.liveText  = this.live
							this.liveClass = this.live === 'online' ? 'success' : 'danger';

							let system = this.$root.store.state.currentSystem
							system.system.live = this.live === 'online' ? true : false
							this.$root.store.setSystemData(system)
						}
					}).catch((err) => {
						if (err.response.data.error === "Unverified email") {
							this.$root.showAlert(this.$t('warnings.liveUnverifiedEmail'), {variant:'danger'})
						} else {
							this.$root.handleRequestError(err);
						}
					});

					close()
				}
			})
			console.log(this.live);
			console.log(this.$root.store.state.currentSystem.system.live)
		},
	},
	beforeCreate() {
		if(this.$root.store.state.currentUser.emailValidationStatus === 'unverified_email') {
			this.$root.api.post(`/users/validate-email-verification`).then((res) => {
				this.emailVerified = res.data
			}).catch(err => {
				this.$root.handleRequestError(err)
			});
		}
	},
	computed: {
		user() {
			if(this.$root.store.state.currentUser)
				return this.$root.store.state.currentUser;
			else
				return ''
		},
		system() {
			if(this.$root.store.state.currentSystem)
				return this.$root.store.state.currentSystem.system;
			else
				return ''
		},
		warningProps() {
			return this.$root.warningProps;
		},
		alertProps() {
			return this.$root.alertProps;
		}
	},
	mounted() {
		this.liveText  = this.$root.store.state.currentSystem.system.live ? 'online' : 'offline'
		this.liveClass = this.$root.store.state.currentSystem.system.live ? 'success' : 'danger'
	}
};
</script>

<style>
html,
body {
	background: #e3e1fd;
}
.container {
	max-width: 1500px;
	margin-bottom: 20px;
}
.box {
	background: #fff;
	padding: 1.5em;
}
.material-icons {
	font-size: 130% !important;
	vertical-align: text-bottom !important;
}
.col-form-label {
	padding-bottom: 0;
}
.form-group {
	margin-bottom: 0.3rem;
}
.modal hr {
	margin-bottom: 0.5rem;
	margin-top: 0.5rem;
}
.btn-group-sm > .btn,
.btn-sm {
	padding: 0.15rem 0.4rem;
}
.modal-header,
.modal-footer {
	padding: 0.5em 1em;
}
#headernav .navbar-nav .nav-link {
	color: #d1d1ed !important;
}
#headernav {
	background-color: #021d3e !important;
	margin-bottom: 20px;
	border-bottom: 2px solid #d1d1ed;
}
.container > .box {
	border: 2px solid #021d3e;
}

/* new status color */
.table-partialCancellation:hover {
	background-color: #fd9b49 !important;
}
.table-partialCancellation tbody+tbody, .table-partialCancellation td, .table-partialCancellation th, .table-partialCancellation thead th {
	border-color: #db7849;
}
.table-partialCancellation, .table-partialCancellationy>td, .table-partialCancellation>th {
	background-color: #ffab65 !important;
}
.badge-partialCancellation {
	background-color: #fd7e14;
}



</style>

<style scoped>
#App {
	position: relative;
	min-height: 100vh;
	overflow: hidden;
}
#AppWrap {
	padding-bottom: 5rem;
}
#logo {
	max-width: 200px;
}

.menu-icon{
	color: #fff;
}

footer {
	position: absolute;
	bottom: 0;
	width: 100%;
	text-align: center;
	padding: 10px;
	height: 5rem;
	background-color: #021d3e;
}
footer img {
	max-height: 100%;
}

.fab-contact {
	position: fixed;
	bottom: 24px;
	z-index: 15;
	display: block;
	right: 24px;
}

.fab-contact button {
	width: 60px;
	height: 60px;
	font-size: 30px;
	padding: 2px 3px 0;
	border-radius: 50%;
}

.notification {
	font-size: 26px !important;
}
.notification-badge {
	top: 4px;
	left: 22px;
}
</style>
